import React from 'react'
import { Button, Grid, Image, Select } from 'semantic-ui-react'
import './Peliculas.scss'
import {withRouter, Link}from 'react-router-dom'
import {map} from 'lodash'
import db, { storage } from '../../utils/firebase'

import { useAuth } from '../../context/authContext'
import { morePeliculas, morePeliculasSinType } from '../../utils/Validations'
import InfiniteScroll from 'react-infinite-scroll-component'





 function Peliculas() {

    const {startPeliculas,setStartPeliculas,listaSeleccionada,setListaSeleccionada,peliculas,setPeliculas} =useAuth()
    const [hasMore,setHasMore] = React.useState(true)

    const limite = 20

   const opciones=[
        {key: "1", text: "accion", value: "accion"},
        {key: "2", text: "romance", value: "romance"},
        {key: "3", text: "terror", value: "terror"},
        {key: "4", text: "comedia", value: "comedia"},
        {key: "5", text: "drama", value: "drama"},
        {key: "6", text: "adolescentes", value: "adolescentes"},
        {key: "7", text: "animado e infantil", value: "animado e infantil"},

        {key: "8", text: "ciencia ficcion", value: "ciencia ficcion"},
        {key: "9", text: "documentales", value: "documentales"},
        {key: "10", text: "aventura", value: "aventura"},
        {key: "11", text: "historia", value: "historia"},
        {key: "12", text: "familiar", value: "familiar"},





    ]

  

    const handleVerMas =  ()=>{
        setTimeout(async()=>{

            if(!startPeliculas){
                setHasMore(false)
    
                return
            }
            if(listaSeleccionada.value ==="sinselect"){
                const response = await morePeliculasSinType(limite,startPeliculas)
                if(response.statusResponse){
                    setStartPeliculas(response?.startPeliculas)
                    setPeliculas([...peliculas,...response?.peliculas])
        
                }

            }else{

                const response = await morePeliculas(listaSeleccionada.value,limite,startPeliculas)
                if(response.statusResponse){
                    setStartPeliculas(response?.startPeliculas)
                    setPeliculas([...peliculas,...response?.peliculas])
        
                }
            }
            /// setLoading(true)
            // setLoading(false)
        },500)

    }

    

    





    return (
        <div className="peliculas-banner" >
            <Select 
                className="select-pelis"
                placeholder="PLAY AF" 
               // onChange={(e, data) => setListP({...listP,list:data?.value})}
               onChange={(text, data) => setListaSeleccionada({...listaSeleccionada,value:data.value})}
                options={opciones} 
                />
                {
                    peliculas?.length>0 &&
                        <InfiniteScroll
                            dataLength={peliculas.length}
                            className='infiniti'
                            
                            next={()=>handleVerMas()}
                                hasMore={hasMore}
                                scrollableTarget="scrollableDiv"
                        >
                            <Grid>

                                <Grid.Row only="computer" columns="6">
                                    {
                                        map(peliculas, item =>(
                                            <RenderPeliculas key={item.uuidPoster}  item={item}  />
                                        ))
                                    }
                                    
                                </Grid.Row>
                                <Grid.Row only="mobile" columns="3">
                                    {
                                        map(peliculas, item =>(
                                            <RenderPeliculas key={item.uuidPoster}  item={item}  />
                                        ))
                                    }
                                    
                                </Grid.Row>
                                <Grid.Row only="tablet" columns="6">
                                    {
                                        map(peliculas, item =>(
                                            <RenderPeliculas key={item.uuidPoster} item={item}  />
                                        ))
                                    }
                                    
                                </Grid.Row>
                            </Grid>
                        </InfiniteScroll>
                    
                }
            
            
        </div>
    )
}



export default withRouter(Peliculas)

 function RenderPeliculas({item}){



    return(

        <Grid.Column>
            <Link to={`/pelicula/${item.uuidPoster}`}>
                <Image src={item.urlPoster} />
                <h2>{item.title}</h2>
            </Link>
            
        </Grid.Column>
    )
}